<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12uyLqF/tc-custom/9781788631006.jpg?1704918547584" alt="This image is the cover for the book Rack, Ruin and Murder, A Campbell and Carter Mystery"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Rack, Ruin and Murder, A Campbell and Carter Mystery
      </h1>
      <p class="bookDescription body article font2">
        <b>“Fans of Granger’s earlier Mitchell and Markby series will not be disappointed with the crimes put before Campbell and Carter.” —<i>Oxford Mail</i></b><br/>  <br/> When old Monty Bickerstaffe discovers a dead body in his drawing room, it’s up to Inspector Jess Campbell to get to the bottom of the mystery.<br/>  <br/> Monty is a recluse, holed up in his crumbling manor house being generally unpleasant to everyone, even those relatives he actually likes. When his family and locals claim they’ve never seen the murder victim before, Campbell smells a lie.<br/>  <br/> With the help of Superintendent Ian Carter, she will have to dig deep into the murky past of Monty and his family, all the way to the shocking truth.<br/>  <br/><i>Rack, Ruin and Murder</i> is a pulse-pounding adventure, perfect for fans of T. E. Kinsey, Ann Cleeves and Faith Martin.<br/>  <br/><b>Praise for the writing of Ann Granger</b><br/>  <br/> “A well-written, well-crafted traditional British mystery by a writer with an assured grasp of her technique.” —<i>reviewingtheevidence.com</i><br/>  <br/> “Characterization, as ever with Granger, is sharp and astringent.” —<i>The Times</i><br/>  <br/> “The story just gets more complex, mysterious and chilling.” —<i>Good Book Guide</i><br/>  <br/> “For once a murder novel which displays a gentle touch and a dash of wit.” —<i>The Northern Echo</i><br/>  <br/> “A clever and lively book.” —Margaret York
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ann Granger
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Canelo Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?55f29a92